import useQueryWithTracing from '@aurora/shared-client/components/useQueryWithTracing';
import React, { useContext } from 'react';
import type {
  ProfileUserQuery,
  ProfileUserQueryVariables,
  UserViewFragment
} from '../../../types/graphql-types';
import BanUserDetails from '../../bans/BanUserDetails/BanUserDetails';
import userQuery from '../UserProfileWidget/UserProfileWidget.query.graphql';
import AppContext from '@aurora/shared-client/components/context/AppContext/AppContext';

interface Props {
  /**
   * Whether the modal is currently being displayed
   */
  show: boolean;
  /**
   * Callback function when the modal is hidden or cancelled
   *
   * @callback
   */
  onHide?: () => void;
}

/**
 * UserProfileActionBanMember Component
 * Renders ban member menu item on required places.
 *
 * @author Elamaran P
 */
const UserProfileActionBanMember: React.FC<React.PropsWithChildren<Props>> = ({ show, onHide }) => {
  const { contextUser } = useContext(AppContext);
  const queryResult = useQueryWithTracing<ProfileUserQuery, ProfileUserQueryVariables>(
    module,
    userQuery,
    {
      variables: {
        id: contextUser?.id
      }
    }
  );
  const userData = queryResult?.data?.user;
  const UserDataLoading = queryResult?.loading;

  if (UserDataLoading) {
    return null;
  }

  return <BanUserDetails show={show} onHide={onHide} user={userData as UserViewFragment} />;
};

export default UserProfileActionBanMember;
